import sanityClient from "./sanityClient"; // Adjust the path to your Sanity client
import imageUrlBuilder from "@sanity/image-url";

const builder = imageUrlBuilder(sanityClient);

const fetchSponsors = async () => {
  try {
    const query = `*[_type == "sponsors"][0]{
      title,
      "image": image.asset->url,
      content
    }`;

    const data = await sanityClient.fetch(query);

    // Optimize image URL if available
    const optimizedData = {
      ...data,
      imageUrl: data.image ? `${data.image}?w=1200&h=900&fm=webp&q=80` : null,
    };

    return optimizedData;
  } catch (error) {
    console.error("Error fetching Sponsors data:", error);
    return null;
  }
};

export default fetchSponsors;